export default __webpack_public_path__ + "static/media/ys4.a2ffcbea.jpg";